import React from 'react'

const TopMenu = ({ setActiveTab, activeTab }) => {
	return (
		<div className='mt-5 rounded-[24px] border border-slate-200 bg-white px-5 py-4 shadow-[0_16px_36px_rgba(15,23,42,0.07)]'>
			<div className='flex flex-wrap items-center gap-2'>
				{[
					{ id: 'all', label: 'All Assignments' },
					{ id: 'currentday', label: 'Today' },
				].map((item) => {
					const active = activeTab === item.id
					return (
						<button
							key={item.id}
							type='button'
							onClick={() => setActiveTab(item.id)}
							className={`rounded-full px-4 py-2 text-sm font-[GilroyMedium] transition-all ${
								active
									? 'bg-[#fff4ed] text-[#f97316] shadow-[inset_0_0_0_1px_rgba(249,115,22,0.12)]'
									: 'text-slate-500 hover:bg-slate-100 hover:text-slate-800'
							}`}
						>
							{item.label}
						</button>
					)
				})}
			</div>
		</div>
	)
}

export default TopMenu
